
































// Importing components
import TheFormStaff from '@/components/staff/TheFormStaff.vue';
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
import BaseCard from '@/ui/BaseCard.vue';
import LayoutApp from '@/layputs/LayoutApp.vue';
// Importing functions
import {validateUpdateUser} from '@/ts/users/validate-user';
import {putStaff} from '@/ts/staff/put-staff';
import {getStaffData} from '@/ts/staff/get-staff-data';

export default {
    name: 'PageUsersUpdate',
    components: {
        LayoutApp,
        BaseCard,
        TheFormStaff,
        BaseLoadingAnimation,
    },
    props: {},
    data() {
        return {
            userData: {},
            items: [],
            errors: [],
        };
    },
    methods: {
        onSubmit() {
            this.errors = [];

            validateUpdateUser(this.errors, this.userData);

            if (this.errors.length === 0) {
                putStaff(this.userData, this.$route.params.id, this.$route.params.user_id).then(() => {
                    this.$router.push({ name: 'staff', params: { id: this.$route.params.id} });
                });
            }
        },
    },
    created() {
        // Initializing the items object
        this.items = [{
            text: 'Панел',
            to: { path: '/dashboard' },
        }, {
            text: 'Ресторанти',
            to: { path: '/restaurants' },
        }, {
            text: 'Служители',
            to: { name: 'staff', params: { id: this.$route.params.id} },
        }, {
            text: 'Редактиране',
        }];
        // Initializing the user data object
        this.userData = {
            first_name: '', last_name: '', email: '',
            phone: '', password: '', password_confirmation: '',
            id: this.$route.params.id,
        };
        this.$store.dispatch('setLoadingOn');
        // Fetching data from the API
        getStaffData(this.$route.params.id, this.$route.params.user_id).then((response: any) => {
            this.userData = { ...this.userData, ...response.data.attributes };
            this.userData.roles = response.data.relationships.roles;
            this.userData.permissions = response.data.relationships.permissions;
        }).finally(() => {
            this.$store.dispatch('setLoadingOff');
        });
    },
};
